<ps-ui-modal>
  <div class="ps-modal-header" psUiModalTitle>
    <h5>PSID Upload History</h5>
  </div>
  <ps-ui-modal-body>
    <div class="history-actions">
      <button type="button" psUiButton (click)="getPSIDUploadHistory()">
        Refresh
      </button>
    </div>
    <div class="table-responsive psid-upload-history">
      <table class="table table-sm table-bordered">
        <thead>
          <tr>
            <th>File Name</th>
            <th>Uploaded By</th>
            <th>Uploaded Date</th>
            <th>Status</th>
            <th>Total PSIDs</th>
            <th>Processed PSIDs</th>
            <th>Whitelisted</th>
            <th>Not Whitelisted</th>
            <th>Blacklisted</th>
            <th>Not Blacklisted</th>
            <th>Not Processed</th>
            <th>Error Message</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="isPSIDUploadHistoryLoading">
            <td colspan="12">Loading...</td>
          </tr>
          <tr
            *ngFor="let item of psidUploadHistory"
            [hidden]="isPSIDUploadHistoryLoading"
          >
            <td>{{ item.fileName || '-' }}</td>
            <td>{{ item.uploadedBy || '-' }}</td>
            <td>{{ item.createdAt | date : 'medium' }}</td>
            <td>{{ item.status || '-' }}</td>
            <td>{{ item.totalPsids || 0 }}</td>
            <td>{{ item.processedPsids || 0 }}</td>
            <td>{{ item.whitelistedCount || 0 }}</td>
            <td>{{ item.notWhitelistedCount || 0 }}</td>
            <td>{{ item.blacklistedCount || 0 }}</td>
            <td>{{ item.notBlacklistedCount || 0 }}</td>
            <td>{{ item.notProcessedCount || 0 }}</td>
            <td>{{ item.errorMessage || '-' }}</td>
          </tr>
          <tr *ngIf="!isPSIDUploadHistoryLoading && !psidUploadHistory.length">
            <td colspan="12">No upload history found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer position="center">
    <button type="button" class="close-btn" (click)="close()">Close</button>
  </ps-ui-modal-footer>
</ps-ui-modal>
